import Script from 'next/script';
import React from 'react';

import HeadMeta from '@/components/static-pages/HeadMeta';
import LocalityDirectoryByTypeTemplate from '@/components/templates/LocalityDirectoryByTypeTemplate';
import getPageData from '@/services/getPageData.js';

const LocalityDirectoryByType = props => {
  const { title, seo_description, locality, canonical_url, top_localities_type } = props.metadata;

  const pageTitle = title;
  const pageSEODescription =
    seo_description ||
    `Discover the best RV Rental, Motorhome and camper options in ${locality.title}. Find more Class A, Class C, Class B, trailers, fifth wheel trailers and more at Outdoorsy!`;

  const isCampground = top_localities_type === 'campground';
  return (
    <React.Fragment>
      <HeadMeta
        title={pageTitle}
        description={pageSEODescription}
        canonicalUrl={canonical_url}
        noindex={!!props.fallback}
      />
      {isCampground && <Script src={process.env.convertFlowScript} strategy="beforeInteractive" />}
      <LocalityDirectoryByTypeTemplate {...props} />
    </React.Fragment>
  );
};

LocalityDirectoryByType.getInitialProps = async ({ req, res, query }) => {
  const pageData = await getPageData({ req, res, query });

  return { ...pageData };
};

export default LocalityDirectoryByType;
